import { Component, ViewEncapsulation, TemplateRef, input, computed, contentChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { FormValidationErrorComponent } from '../form-validation-error/form-validation-error.component';

@Component({
    selector: 'app-form-control',
    templateUrl: './form-control.component.html',
    styleUrls: ['./form-control.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [NgTemplateOutlet, FormValidationErrorComponent]
})
export class FormControlComponent {
  label = input<string | undefined>(undefined);
  required = input(false);
  disabled = input(false);
  control = input<AbstractControl | null | undefined>(undefined);
  errorMessage = input<string | undefined>(undefined);
  hint = input<string | undefined>(undefined);
  labelClass = input<string | undefined>(undefined);
  containerClass = input<string | undefined>(undefined);

  labelTemplate = contentChild<TemplateRef<unknown>>('labelTemplate');
  hintTemplate = contentChild<TemplateRef<unknown>>('hintTemplate');

  hasError = computed(() => {
    const ctrl = this.control();
    return !!(ctrl?.invalid && ctrl?.touched);
  });

  errorText = computed(() => {
    const msg = this.errorMessage();
    if (msg) {
      return msg;
    }

    const ctrl = this.control();
    if (!ctrl?.errors) {
      return '';
    }

    const errors = ctrl.errors;

    if (errors['required']) {
      return `${this.label() || 'This field'} is required`;
    }
    if (errors['email']) {
      return 'Please enter a valid email address';
    }
    if (errors['minlength']) {
      return `Minimum length is ${errors['minlength'].requiredLength} characters`;
    }
    if (errors['maxlength']) {
      return `Maximum length is ${errors['maxlength'].requiredLength} characters`;
    }
    if (errors['min']) {
      return `Minimum value is ${errors['min'].min}`;
    }
    if (errors['max']) {
      return `Maximum value is ${errors['max'].max}`;
    }
    if (errors['pattern']) {
      return 'Please enter a valid format';
    }

    return 'Invalid input';
  });
}
